export default "__VITE_ASSET__rajJsCah__"